import './ProductVariants.scss'

import React, {useEffect, useState} from 'react'
import {Meta} from 'util/cart'
import {style} from 'util/style'
import {Dropdown} from 'views/ui/Dropdown'
import {ProductVariationType} from 'views/webshop/pages/WebshopProduct'

const styles = style('productvariants')

type ProductVariantsType = {
	variations: Array<ProductVariationType>
	onChange?: (groupId: string, id: string) => void
	meta?: Meta
	inCart?: boolean
}

export const ProductVariants: React.FC<ProductVariantsType> = ({
	meta,
	onChange,
	variations,
	inCart = false
}) => {
	if (!variations || variations.length === 0) return null
	return (
		<div className={styles}>
			{variations.map(
				({options, title: varTitle, id: varId = null, filteredOptions}) => {
					const selected = meta && meta[varId]
					const selectedOption = getVariantOptionValueById(
						variations,
						varId,
						Number(selected)
					)
					if (!options || !varId) return null
					return (
						<Dropdown
							key={varId + '_' + Number(selected)}
							onChange={(dropdownId) => {
								onChange(varId, dropdownId)
							}}
							items={filteredOptions || options}
							selected={selectedOption}
							itemPropertyToUse={'id'}
							customLabelName={varTitle}
							defaultText={'-'}
							clearInputOnClick={!inCart}
						/>
					)
				}
			)}
		</div>
	)
}
const getVariantOptionValueById = (
	variations: Array<ProductVariationType>,
	typeId: string,
	optionId: number
) => {
	const variantType = getVariantTypeById(variations, typeId)
	return variantType.options.find((option) => Number(option.id) === optionId)
}

const getVariantTypeById = (
	variations: Array<ProductVariationType>,
	typeId: string
) => {
	return variations.find((type) => type.id === typeId)
}
